import {
  ArrowRightIcon,
  EmailIcon,
  LocationIcon,
  PhoneIcon,
} from "@design-system/icons";
import { trans } from "@mongez/localization";

export function ContactUsInfo() {
  return (
    <div className="relative -mt-[100px] bg-[#f7f9fc] py-20 text-marine">
      {/* <div className="absolute left-0 top-0 h-[362px] w-full bg-gradient-to-b from-[#000D2E] to-transparent"></div> */}
      {/* <div className="absolute left-0 top-0 size-[330px] animate-pulse rounded-full bg-secondary blur-[100px] animate-infinite animate-ease-linear"></div> */}
      <div className="container relative z-20 flex w-full flex-wrap items-start justify-between gap-10 lg:gap-14 2xl:flex-nowrap">
        <h2 className="text-[28px] font-medium sm:text-[32px] lg:text-[48px]">
          {trans("contactUsPage.senaatInformation")}
        </h2>

        <div className="flex w-[800px] flex-col gap-10 text-sm sm:text-base lg:gap-20 lg:text-lg">
          <div className="flex w-full flex-wrap items-center justify-between gap-10 md:flex-nowrap lg:gap-20">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-2">
                <span>
                  <LocationIcon />
                </span>
                <span className="text-bright-orange">
                  {trans("data.P.O. Box 14441")}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-bright-orange ltr:rotate-0 rtl:-rotate-180">
                  <ArrowRightIcon />
                </span>
                <span>{trans("data.Dammam 31424")}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-bright-orange ltr:rotate-0 rtl:-rotate-180">
                  <ArrowRightIcon />
                </span>
                <span>{trans("data.Saudi Arabia")}</span>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-2">
                <span className="ltr:rotate-0 rtl:-rotate-90">
                  <PhoneIcon />
                </span>
                <span className="flex flex-col gap-2">
                  <span className="font-semibold text-bright-orange">
                    {trans("tel")}
                  </span>
                  <a
                    dir="ltr"
                    className="hover:underline ltr:text-left rtl:text-right"
                    href="tel:+966 13 810 8111"
                  >
                    +966 13 810 8111
                  </a>
                </span>
              </div>
              <div className="flex items-start gap-2">
                <span>
                  <LocationIcon />
                </span>
                <span className="flex flex-col gap-2">
                  <span className="font-semibold text-bright-orange">
                    {trans("fax")}
                  </span>
                  <a
                    dir="ltr"
                    className="hover:underline ltr:text-left rtl:text-right"
                    href="tel:+966 13 810 8199"
                  >
                    +966 13 810 8199
                  </a>
                </span>
              </div>
              <div className="flex items-start gap-2">
                <span>
                  <EmailIcon />
                </span>
                <span className="flex flex-col gap-2">
                  <span className="font-semibold text-bright-orange">
                    {trans("email")}
                  </span>
                  <a href="mailto:info@senaat.com" className="underline">
                    info@senaat.com
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="ltr:rotate-0 rtl:-rotate-90">
                <PhoneIcon />
              </span>
              <span className="font-semibold text-bright-orange">
                {trans("data.National Address (Wasel)")}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-bright-orange ltr:rotate-0 rtl:-rotate-180">
                <ArrowRightIcon />
              </span>
              <span>{trans("data.Building 4416, Unit 2")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-bright-orange ltr:rotate-0 rtl:-rotate-180">
                <ArrowRightIcon />
              </span>
              <span>{trans("data.Dammam 32234-7590")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-bright-orange ltr:rotate-0 rtl:-rotate-180">
                <ArrowRightIcon />
              </span>
              <span>{trans("data.Kingdom of Saudi Arabia")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
